import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import Drawer from '../../ui/Drawer'
import ActionsMenu from '../../ui/ActionsMenu'
import Tooltip from '../../ui/Tooltip'
import EllipsisIcon from '../../ui/icons/EllipsisIcon'
import DownloadIcon from '../../ui/icons/DownloadIcon'
import ShareNodesIcon from '../../ui/icons/ShareNodesIcon'
import { formatDateTime } from '../../../utils/dateHelpers'

const PDF_URL_KEY = 'pdf_url'
const UPDATED_AT_KEY = 'updated_at'

const HEADER_BORDER_CLASS = 'tw:border-gray-200!'
const HEADING_CLASS = 'tw:flex-1 tw:text-base! tw:leading-5! '
  + 'tw:font-medium! tw:text-gray-900! tw:m-0! tw:min-w-0 tw:truncate'
const HASH_CLASS = 'tw:text-gray-400'
const META_CLASS = 'tw:text-sm tw:text-gray-500 tw:whitespace-nowrap'
const ACTION_CLASS = 'tw:inline-flex tw:items-center tw:justify-center tw:size-9 '
  + 'tw:rounded! tw:bg-transparent tw:border-0 tw:cursor-pointer tw:text-gray-600 '
  + 'tw:no-underline! tw:hover:bg-gray-100 tw:hover:text-slate-700 tw:shrink-0'
const CLOSE_BUTTON_CLASS = 'tw:inline-flex tw:items-center tw:justify-center tw:size-9 '
  + 'tw:rounded! tw:bg-white tw:border tw:border-solid tw:border-gray-300 tw:cursor-pointer '
  + 'tw:text-gray-600 tw:hover:bg-gray-100 tw:hover:border-slate-300 tw:hover:text-slate-700 '
  + 'tw:focus-visible:outline-none'
const PADDING_CLASS = 'tw:px-6 tw:py-4'

const IssueDrawerHeader = ({ issue, onClose, onShare }) => {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleMenuToggle = useCallback(event => {
    setMenuAnchor(event.currentTarget)
    setMenuOpen(open => !open)
  }, [])
  const handleMenuClose = useCallback(() => setMenuOpen(false), [])
  const handleExport = useCallback(() => {
    window.open(issue[PDF_URL_KEY], '_blank', 'noopener,noreferrer')
  }, [issue])

  const items = [
    { label: 'Exporter', icon: DownloadIcon, onClick: handleExport },
    { label: 'Partager', icon: ShareNodesIcon, onClick: onShare }
  ]

  return (
    <Drawer.Header
      className={HEADER_BORDER_CLASS}
      closeButtonClassName={CLOSE_BUTTON_CLASS}
      closeTooltip="Fermer"
      closeVariant="dismiss"
      paddingClassName={PADDING_CLASS}
      onClose={onClose}
    >
      <h2 className={HEADING_CLASS}>
        {'Alerte '}
        <span className={HASH_CLASS}>#</span>
        {issue.id}
      </h2>
      <span className={META_CLASS}>{`Dernière édition : ${formatDateTime(issue[UPDATED_AT_KEY])}`}</span>
      <Tooltip className="tw:inline-flex" content="Options" placement="bottom">
        <button
          aria-haspopup="menu"
          aria-label="Options de l’alerte"
          className={ACTION_CLASS}
          type="button"
          onClick={handleMenuToggle}
        >
          <EllipsisIcon className="tw:size-5" />
        </button>
      </Tooltip>
      <ActionsMenu
        anchorEl={menuAnchor}
        ariaLabel="Actions sur l’alerte"
        isOpen={menuOpen}
        items={items}
        onClose={handleMenuClose}
      />
    </Drawer.Header>
  )
}

IssueDrawerHeader.propTypes = {
  issue: PropTypes.shape({
    id: PropTypes.number.isRequired,
    [PDF_URL_KEY]: PropTypes.string,
    [UPDATED_AT_KEY]: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired
}

export default IssueDrawerHeader
